<template>
  <div class="rfb">
    <ul>
      <li class="idx-l-item">
        <a class="idx-l-item-w" @click="checkQDP">
          <img src="@/assets/image/qdkp.png" alt="" />
          <a class="idx-l-i-txt">全电发票</a>
        </a>
      </li>
      <li class="idx-l-item">
        <a class="idx-l-item-w" href="skpkp://kp">
          <img src="@/assets/image/ticket.png" alt="" />
          <!-- <div class="idx-l-i-txt">税控盘开票</div> -->
          <a class="idx-l-i-txt">税控盘开票</a>
        </a>
      </li>

      <li
        class="idx-l-item"
        v-for="(item, index) in recentProducts"
        :key="index"
      >
        <a class="idx-l-item-w" :href="item.goodsUrl" target="_blank">
          <img :src="tImgUrl(item.image.split(',')[0])" alt="" />
          <!--img src="@/assets/image/fake_pic.png" alt=""-->
          <a class="idx-l-i-txt">{{ item.name }}</a>
        </a>
      </li>

      <li class="idx-l-item" v-if="recentProducts.length < 4">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/fake_pic.png" alt="" />
          <div class="idx-l-i-txt">发票真伪查询</div>
        </div>
      </li>
      <li class="idx-l-item" v-if="recentProducts.length < 3">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://fpdk.sichuan.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/fake_pic.png" alt="" />
          <div class="idx-l-i-txt">发票综合服务平台</div>
        </div>
      </li>
      <li
        class="idx-l-item"
        style="border: 0px"
        v-if="recentProducts.length < 2"
      >
        <div
          class="idx-l-item-w"
          onClick="window.open('https://etax.sichuan.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/fake_pic.png" alt="" />
          <div class="idx-l-i-txt">四川省电子税务局</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import API from '@/api/api'
import { mapGetters } from 'vuex'
import { usrStatus } from '@/util/mixin'

export default {
  mixins: [usrStatus],
  name: 'rightFLoatBar',
  props: [],
  isShow: false,
  data() {
    return {
      recentProducts: [],
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'memberInfo']),
  },
  mounted() {
    console.log('right-float mounted')
    this.initPage()
    this.$store.dispatch('getMemberInfo')
  },
  activated() {
    // this.initPage()
    //this.$store.dispatch('getMemberInfo')
  },
  methods: {
    //校验是否可以开qdp
    checkQDP() {
            location.href =
        'https://www.chinaqjwx.cn/qjyweb/#/cloudLogin'
      return
      if (!this.isLogin) {
        this.$emit('openLoginDialog', true)
        return
      }
      if (this.userInfo.dzswjzh) {
        this.$emit('openPay')
        //调用一键登录
      } else {
        this.$alert('您还未完善全电相关信息，请先完善信息', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
        }).then(() => {
          //完善信息
          this.$router.push({
            name: 'userInfo',
            query: { op: 'qd' },
          })
        })
      }
    },
    openPay() {},
    async initPage() {
      //console.log("init page...")
      //console.log(this.userInfo.id);
      //console.log("get products...")
      // if(this.userInfo.id ) {
      const productsRlt = await API.getMyProducts({
        memberId: this.userInfo.id,
        useOrder: 0,
        currentPage: 1,
        pageSize: 4,
      })
      this.recentProducts = productsRlt.data.result.records
      console.log('myproducts:')
      console.log(productsRlt.data.result.records)
    },
  },
}
</script>

<style lang="stylus" scoped>
.rfb
  position fixed
  right 0px
  z-index 99
  text-align center
  width 60px
  margin-top 70px
  background-color white
  padding 0px 12px
  box-shadow rgba(16, 36, 94, 0.4) 0 2px 6px 0
  border 1px solid #eee
  .idx-l-item
    margin-top 10px
    center()
    border-bottom 1px solid #CCCCCC
    flex 1 1 25%
    height 100%
    position relative
    &:hover
      cursor pointer
    .idx-l-item-w
      width 60px
      text-decoration none
      &:hover
        cursor pointer
      img
        display inline-block
        width 44px
        height auto
      .idx-l-i-txt
        display block
        color #333333
        font-weight 400
        text-align center
        width 60px
        margin 10px 0px
        font-size 10px
        text-decoration none
</style>
